import { Component, OnInit } from '@angular/core';
import { COMMUNITY_URL} from '../../app.constants';

@Component({
    selector: 'u4-cpp-community',
    template: ''
})
export class CommunityComponent implements OnInit {

    constructor() {}

    ngOnInit() {
        window.location.href = COMMUNITY_URL;
    }
}
